import { createSelector } from 'reselect';

import { FLAG_KEYS } from 'lib/constants';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';

const getEmbeddedLaborTicketFlowEnabled = createSelector(
  [getLaunchDarklyFlags, getIsApmERPJobFlow],
  (flags, isApmERPJobFlow) => {
    return !!(
      isApmERPJobFlow || flags?.[FLAG_KEYS.EMBEDDED_LABOR_TICKET_FLOW_ENABLED]
    );
  }
);

export { getEmbeddedLaborTicketFlowEnabled };
